import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    id: "js-preview-dialog",
    class: "dialog p-topPreview",
    style: { "display": "block", "z-index": "500" }
};
const _hoisted_2 = { class: "p-topPreview__inner" };
const _hoisted_3 = /*#__PURE__*/ _createStaticVNode("<h2 class=\"p-topPreview__title\">プレビュー</h2><div class=\"p-topPreviewContents\"><div class=\"p-topPreviewContents__left\"><h3 class=\"p-topPreview__subtitle\">修正前</h3><div><pre id=\"js-before-preview\"></pre></div></div><div class=\"p-topPreviewContents__right\"><h3 class=\"p-topPreview__subtitle--blue\">修正後</h3><div><pre id=\"js-after-preview\"></pre></div></div></div>", 2);
const _hoisted_5 = { class: "p-topPreview__btns" };
const _hoisted_6 = ["data-tooltip"];
const _hoisted_7 = ["disabled"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'PreviewModal',
    props: {
        closeModal: { type: Function },
        onExport: { type: Function },
        isProofreadExportEnabled: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            class: "c-tooltip",
                            "data-tooltip": !_ctx.isProofreadExportEnabled ? 'プランのアップグレードが必要です' : null
                        }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "p-topPreview__btn",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.onExport && _ctx.onExport(...args))),
                                disabled: !props.isProofreadExportEnabled
                            }, "書き出す ", 8, _hoisted_7)
                        ], 8, _hoisted_6),
                        _createElementVNode("button", {
                            type: "button",
                            id: "js-close-preview",
                            class: "p-topPreview__btn",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                        }, "閉じる")
                    ])
                ])
            ]));
        };
    }
});
